import React from "react";
import Scaffold from "../../widget/layouts/Scaffold";
import { ResponsiveDeviceType } from "../../widget/layouts/ScreenMedia";
import { DashboardContextProvider } from "../../provider/dashboard/DashboardContextProvider";
import DashboardAppBar from "./widget/DashboardActions";
import { HomeContextProvider } from "../../provider/home/HomeContextProvider";

type DashboardType = {
  title: string | undefined;
  actions?: React.ReactNode;
  navIndex: number;
  children: React.ReactNode;
  yCenter?: boolean | false;
  className?: string;
};

const DashboardLayout: React.FC<DashboardType> = ({
  title,
  actions,
  navIndex,
  children,
  yCenter,
  className,
}) => {
  const type: number = ResponsiveDeviceType();

  return (
    <HomeContextProvider>
      <DashboardContextProvider>
        <Scaffold
          appBarTitle={title}
          appBarAction={actions}
          yCenter={yCenter}
          showBackArrow={false}
          bottomNavigationBar={
            type === 3 ? undefined : <DashboardAppBar navIndex={navIndex} />
          }
          className={className ?? ""}
        >
          {children}
        </Scaffold>
      </DashboardContextProvider>
    </HomeContextProvider>
  );
};

export default DashboardLayout;
